import { ReactNode } from "react";

export type SummaryField = {
  icon?: string;
  symbol?: string;
  label: string;
  value: ReactNode;
};

interface TransactionSummaryProps {
  entityLabel: string;
  columns: SummaryField[][];
}

const ICON_COLOR = "#9CA3AF";
const TEXT_COLOR = "#626B72";
const ICON_BOX_SIZE = 24;
const ICON_GLYPH_SIZE = 18;
const SYMBOL_FONT_SIZE = 13;

export const SUMMARY_ICON_STYLE = { color: ICON_COLOR } as const;

export const SUMMARY_TEXT_STYLE = { color: TEXT_COLOR } as const;

const SYMBOL_STYLE = {
  color: ICON_COLOR,
  width: ICON_BOX_SIZE,
  display: "inline-block",
  textAlign: "center",
  fontSize: SYMBOL_FONT_SIZE,
  lineHeight: `${ICON_GLYPH_SIZE}px`,
} as const;

const DIVIDER_STYLE = { width: 1, flex: "0 0 auto" } as const;

const TransactionSummary = ({ entityLabel, columns }: TransactionSummaryProps) => (
  <div className="bg-lighter rounded-small padding-15">
    <span className="text-bold">{entityLabel}</span>

    <div className="display-flex flex-wrap gap-15 margin-top-10">
      {columns.map((fields, index) => (
        <div key={fields.map((field) => field.label).join("|")} className="display-flex align-items-center gap-15">
          {index > 0 && <div className="bg-light hidden-xs align-self-stretch" style={DIVIDER_STYLE} />}
          <div className="display-flex flex-column gap-5 min-width-0">
            {fields.map((field) => (
              <div key={field.label} className="display-flex align-items-center gap-5 text-size-14">
                {field.symbol ? (
                  <span className="text-bold" style={SYMBOL_STYLE} aria-hidden="true">
                    {field.symbol}
                  </span>
                ) : (
                  <span className={`rioglyph ${field.icon}`} style={SUMMARY_ICON_STYLE} aria-hidden="true" />
                )}
                <span className="text-medium" style={SUMMARY_TEXT_STYLE}>
                  {field.label}:
                </span>
                <span style={SUMMARY_TEXT_STYLE}>{field.value}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default TransactionSummary;
